import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  checkboxActionStyles,
  checkboxContainerStyles,
  checkboxLabelStyles,
  CheckboxProps,
} from '@kite_aerolab/shared/components';
import { getRandomID } from '@kite_aerolab/shared/utils';

@Component({
  selector: 'kite-checkbox',
  template: `
    <div [ngClass]="checkboxContainer" (click)="handleFocus($event)" (keyup)="handleFocus($event)">
      <label [ngClass]="checkboxLabel" [for]="id" [id]="id + '-label'" [attr.aria-disabled]="isDisabled">
        <input
          #inputRef
          type="checkbox"
          [id]="id"
          [required]="isRequired"
          [attr.value]="value"
          [disabled]="isDisabled"
          [checked]="isChecked"
          [attr.name]="name"
          [attr.aria-label]="ariaLabel || undefined"
          [attr.aria-labelledby]="ariaLabelledby"
          [attr.aria-invalid]="isInvalid"
          [attr.aria-checked]="isChecked"
          [attr.aria-describedby]="ariaDescribedby"
          [attr.aria-disabled]="isDisabled"
          (change)="onChange.emit($event)"
          (click)="onClick.emit($event)"
        />
        <span class="checkmark">
          <kite-icon *ngIf="isIndeterminate" name="indeterminate" class="indeterminate"></kite-icon>
          <kite-icon *ngIf="!isIndeterminate" name="check"></kite-icon>
        </span>
        <span class="label">
          {{ label }}
        </span>
      </label>
      <div [ngClass]="checkboxAction">
        <span *ngIf="actionText" tabindex="0">{{ actionText }}</span>
        <ng-content select="action"></ng-content>
      </div>
    </div>
  `,
})
export class CheckboxComponent {
  focusable = false;
  /**
   * ID del checkbox.
   */
  @Input() id: string = getRandomID();
  /**
   * Required del checkbox.
   */
  @Input() required: boolean;
  /**
   * Checked del checkbox.
   */
  @Input() isChecked = false;
  /**
   * Value del checkbox.
   */
  @Input() value: string;
  /**
   * Name del checkbox.
   */
  @Input() name: string;
  /**
   * Aria Label del checkbox.
   */
  @Input('aria-label') ariaLabel: string;
  /**
   * Css
   */
  @Input() css: CheckboxProps['css'];
  /**
   * Estado deshabilitado del checkbox.
   */
  @Input() isDisabled: boolean;
  /**
   * Label del radio button
   */
  @Input() label: string;
  /**
   * Label del radio button
   */
  @Input() isInvalid: boolean;
  /**
   *
   */
  @Input() isRequired: boolean;
  /**
   *
   */
  @Input() isIndeterminate: boolean;
  /**
   * Texto de la acción del radio button
   */
  @Input() actionText: string;
  @Output() onClick: EventEmitter<any> = new EventEmitter();
  @Output() onChange: EventEmitter<any> = new EventEmitter();

  ariaLabelledby: string;
  ariaDescribedby: string;

  public get checkboxContainer(): string[] {
    return [checkboxContainerStyles({ isFocusable: this.focusable }).className];
  }

  public get checkboxLabel(): string[] {
    return [
      checkboxLabelStyles({
        isInvalid: this.isInvalid,
      }).className,
    ];
  }

  public get checkboxAction(): string[] {
    return [
      checkboxActionStyles({
        isDisabled: this.isDisabled,
      }).className,
    ];
  }

  handleFocus(event: any) {
    this.focusable = !!event.key;
  }

  ngAfterViewInit() {
    this.ariaLabelledby = this.id + '-label';
    this.ariaDescribedby = this.id + '-label';
  }
}
